import { render, staticRenderFns } from "./BodySalesAnalysis.vue?vue&type=template&id=6216751c&scoped=true"
import script from "./BodySalesAnalysis.vue?vue&type=script&lang=js"
export * from "./BodySalesAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodySalesAnalysis.vue?vue&type=style&index=0&id=6216751c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6216751c",
  null
  
)

export default component.exports